import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";

export default function ServiceCard({ service, index = 0 }) {
  const Icon = service.icon;
  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
    e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
  };

  return (
    <Link
      to={`/services#${service.id}`}
      onMouseMove={onMove}
      data-testid={`service-card-${service.id}`}
      className="lux-card gold-brackets relative block p-7 md:p-8 group"
    >
      <div className="flex items-start justify-between">
        <div className="h-12 w-12 flex items-center justify-center border border-[#D4AF37]/30 text-[#D4AF37] bg-black/40">
          <Icon size={22} strokeWidth={1.5} />
        </div>
        <span className="text-[10px] tracking-[0.28em] text-white/40 uppercase">
          0{index + 1}
        </span>
      </div>

      <h3 className="font-display text-2xl md:text-[26px] text-white mt-7 leading-tight">
        {service.title}
      </h3>
      <p className="mt-3 text-sm text-white/65 leading-relaxed">{service.summary}</p>

      <ul className="mt-6 space-y-2">
        {service.points.slice(0, 4).map((p) => (
          <li key={p} className="flex items-start gap-2 text-[13px] text-white/70">
            <Check size={14} className="mt-0.5 text-[#D4AF37] shrink-0" />
            <span>{p}</span>
          </li>
        ))}
      </ul>

      <div className="mt-7 flex items-center justify-between">
        <span className="text-[11px] uppercase tracking-[0.22em] text-[#D4AF37] group-hover:text-[#E5C158] transition-colors">
          Explore Practice
        </span>
        <ArrowUpRight className="text-[#D4AF37] transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" size={18} />
      </div>
    </Link>
  );
}
